<a class="btn" [href]="url" [target]="targetBlank ? '_self' : '_blank'" [innerText]="title"></a>
